import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createStore } from 'vuex';
import Vuesax from 'vuesax3'
//import { FeatherIcon } from 'vue-feather-icons';
//import { FeatherIcon } from '@/components/FeatherIcon.vue';
import Notifications from '@kyvg/vue3-notification';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import VueApexCharts from "vue3-apexcharts";
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { Draggable } from 'vue3-draggable';
import { VueHammer } from 'vue2-hammer';
import BackToTop from 'vue3-back-to-top';
import Multiselect from '@vueform/multiselect';

// Import modules de store
import state from "./store/state"
import getters from "./store/getters"
import mutations from "./store/mutations"
import actions from "./store/actions"

// Css
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/sass/app.scss';
import 'vuesax3/dist/vuesax.css';
import 'vue3-perfect-scrollbar/style.css';
import 'material-icons/iconfont/material-icons.css';
import 'leaflet/dist/leaflet.css';
import "leaflet.pm/dist/leaflet.pm.css";
import 'vue-good-table-next/dist/vue-good-table-next.css';
import '@vueform/multiselect/themes/default.css'
import 'vue-multiselect/dist/vue-multiselect.css';
import i18n from './i18n.js';

const store = createStore({
  state,
  getters,
  mutations,
  actions,
});

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
//app.component('FeatherIcon', FeatherIcon);
app.component('draggable', Draggable);
app.use(Vuesax,{
  theme:{
    colors:{
      primary:'#5b3cc4',
      success:'rgb(23, 201, 100)',
      danger:'rgb(242, 19, 93)',
      warning:'rgb(255, 130, 0)',
      dark:'rgb(36, 33, 69)'
    }
  }
});
app.use(Notifications);
app.use(pinia);
app.use(router);
app.use(store);
app.use(VueApexCharts);
app.use(PerfectScrollbarPlugin);
app.use(VueHammer);
app.use(i18n);
app.component('BackToTop', BackToTop);
app.component('Multiselect', Multiselect)

app.mount('#app');
